import { createFileRoute } from '@tanstack/react-router';
import DepotList from '~/containers/DepotList';

export const Route = createFileRoute('/depots/')({
  component: DepotList,
  validateSearch(search) {
    return {
      page: search.page !== undefined ? Number(search.page) : undefined,
    };
  },
});
